"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const rates_1 = require("../models/rates");
const MarkupMinimumRateBy_1 = require("../models/rates/MarkupMinimumRateBy");
const Adjustments_1 = __importDefault(require("./chargecondition/Adjustments"));
const Assemblies_1 = __importDefault(require("./chargecondition/Assemblies"));
const Receiving_1 = __importDefault(require("./chargecondition/Receiving"));
const Returns_1 = __importDefault(require("./chargecondition/Returns"));
const Shipping_1 = __importDefault(require("./chargecondition/Shipping"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const baseRate_schema_1 = __importDefault(require("./schemas/baseRate.schema"));
class MarkupMinimumRateValidator extends GenericValidator_1.default {
    constructor() {
        super();
        this._shippingConditionValidator = new Shipping_1.default();
        this._returnsConditionValidator = new Returns_1.default();
        this._receivingConditionValidator = new Receiving_1.default();
        this._assembliesConditionValidator = new Assemblies_1.default();
        this._adjustmentsConditionValidator =
            new Adjustments_1.default();
    }
    _shippingConditionValidator;
    _returnsConditionValidator;
    _receivingConditionValidator;
    _assembliesConditionValidator;
    _adjustmentsConditionValidator;
    markupMinimumRateBy = Object.values(MarkupMinimumRateBy_1.MarkupMinimumRateBy);
    _rateDetailSchema = joi_1.default.object({
        conditions: joi_1.default.array()
            .items(joi_1.default.object({
            condition: joi_1.default.object().required(),
            markupMinimumDefinition: joi_1.default.object({
                by: joi_1.default.string()
                    .valid(...this.markupMinimumRateBy)
                    .required(),
                amount: joi_1.default.number().required(),
            }).required(),
        }))
            .required(),
    });
    _rateSchema = joi_1.default.object({
        ...baseRate_schema_1.default,
        rateType: joi_1.default.string()
            .valid(rates_1.RateTypeEnum.MarkupRate, rates_1.RateTypeEnum.MinimumRate)
            .required(),
        detail: this._rateDetailSchema.required(),
        customerId: joi_1.default.string().optional(),
        glAccount: joi_1.default.when('customerId', {
            is: joi_1.default.exist(),
            then: joi_1.default.string().allow('').optional(),
            otherwise: joi_1.default.forbidden(),
        }),
        assignedCustomers: joi_1.default.number().integer().min(0).optional(),
        assignedRateSheets: joi_1.default.number().integer().min(0).optional(),
    });
    validate(rate) {
        super.validate(rate, 'IMarkupMinimumRate', this._rateSchema);
        const issues = [];
        const conditionValidator = this.getConditionValidator(rate.transactionType);
        const conditions = rate.detail.conditions;
        conditions.forEach((condition, index) => {
            issues.push(...(conditionValidator.validate(condition.condition, `$conditions[${index}]`) ?? []));
        });
        if (issues.length > 0) {
            const error = new errors_1.ValidationError();
            error.addValidationIssueList(issues);
            throw error;
        }
    }
    getConditionValidator(transactionType) {
        switch (transactionType) {
            case 'Shipping':
                return this._shippingConditionValidator;
            case 'Returns':
                return this._returnsConditionValidator;
            case 'Receiving':
                return this._receivingConditionValidator;
            case 'Assemblies':
                return this._assembliesConditionValidator;
            case 'Adjustments':
                return this._adjustmentsConditionValidator;
            default:
                throw new Error(`Invalid transaction type ${transactionType} for MarkupMinimumRate`);
        }
    }
}
exports.default = MarkupMinimumRateValidator;
